import { render, staticRenderFns } from "./ffsms-add.vue?vue&type=template&id=44e28cc8&"
import script from "./ffsms-add.vue?vue&type=script&lang=js&"
export * from "./ffsms-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports